<template>
    <div v-loading="dataLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="cover" label="项目封面（视频封面）：">
                        <ImageUpload :url.sync="formData.cover" :urlFull.sync="coverUrl"></ImageUpload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <!-- <el-form-item prop="videoUrl" label="项目视频：">
                        <VideoUpload :url.sync="formData.videoUrl" :urlFull.sync="videoUrl"
                            :cover.sync="coverUrl" @onSuccess="$refs.formData.clearValidate('videoUrl')">
                        </VideoUpload>
                    </el-form-item> -->
                    <el-form-item prop="isShow" label="展示状态：">
                        <el-radio-group v-model="formData.isShow">
                            <el-radio :label="1">展示</el-radio>
                            <el-radio :label="0">隐藏</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="name" label="项目名称：">
                        <el-input v-model="formData.name" :maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item prop="subtitle" label="项目副标题：">
                        <el-input v-model="formData.subtitle" :maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="goodsId" label="关联周边：">
                        <el-input v-model="formData.goodsId" :maxlength="10"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="priceFormat" label="项目价格:">
                        <span slot="label">项目价格：<small>价格为0时乐迷端价格区域显示“敬请期待”</small></span>
                        <el-input-number style="width:100%" v-model="formData.priceFormat" :precision="2"
                            :controls="false" :min="0.00" :max="999999.99"></el-input-number>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="datetimerange" label="申购时间：">
                        <el-date-picker v-model="formData.datetimerange" type="datetimerange" start-placeholder="开始时间"
                            end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']" unlink-panels></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="publicityTime" label="中签公示时间：">
                        <span slot="label">中签公示时间：<small>中签公示时间要大于申购结束时间</small></span>
                        <el-date-picker v-model="formData.publicityTime" type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="tagsList" label="项目标签：">
                        <span slot="label">项目标签：<small>最多设置3个标签</small></span>
                        <el-select v-model="formData.tagsList" multiple filterable allow-create default-first-option
                            :multiple-limit="3">
                            <el-option v-for="(item, index) in formData.tagsList" :key="index" :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="issuer" label="发行方：">
                        <el-input v-model="formData.issuer" :maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="authorObj" label="作者:">
                        <el-select v-model="formData.authorObj" filterable remote placeholder="请输入用户名"
                            :remote-method="searchUser" :loading="userLoading" value-key="id">
                            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="realName" label="申请账号实名要求：">
                        <el-select v-model="formData.realName">
                            <el-option label="账号二要素" :value="1"></el-option>
                            <el-option label="账号三要素" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="technicalSupport" label="技术支持：">
                        <el-input v-model="formData.technicalSupport" :maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="helpUrl" label="H5资源ID：">
                        <el-input v-model="formData.helpUrl" :maxlength="10"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="bannerList" label="Banner元素：">
                        <div class="color-danger">请移步至“运营管理-H5页面配置”管理你的Banner元素</div>
                        <!-- <banner-form ref="bannerForm" :s-list.sync="formData.bannerList" v-if="reFresh"></banner-form> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="detail" label="项目详情：">
                        <tinymce v-model="formData.detail" :height="400" :toolbar="toolbar" :menubar="false"
                            v-if="reFresh"></tinymce>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="page-btns-box MT20">
            <el-button @click="goBack">返 回</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </div>
</template>

<script>
import { fetchUser } from '@/assets/js/commonApi';
import ImageUpload from "@/components/ImageUpload";
import BannerForm from "./components/BannerForm";
import Tinymce from '@/components/Tinymce';

const defaultFormData = {
    id: "",
    author: "",	//作者id
    authorName: "",	//作者名称
    cover: "", //封面地址
    detail: "", //详情介绍	
    endTime: "", //申购结束时间	
    goodsId: "", //周边id	
    isShow: 1,  //是否展示 1：展示 0：隐藏	
    issuer: "", //发行方	
    name: "", //项目名称	
    priceFormat: 0, //价格格式化	
    publicityTime: "", //公示时间	
    realName: 1, //实名认证要求 1:二要素 2:人脸	
    startTime: "", //申购开始时间	
    tagsList: [], //标签
    technicalSupport: "", //技术支持	
    // videoUrl: "", //视频地址	
    bannerList: [], //banner元素格式化	
    helpUrl: "", //帮助页地址	
    subtitle: "", //副标题	

    datetimerange: null, //时间区间
    authorObj: null, // 作者
}

export default {
    props: {
        id: {
            type: [String, Number],
            default: ""
        }
    },
    components: { ImageUpload, BannerForm, Tinymce },
    data() {

        const checkTag = (rule, value, callback) => {
            let flag = true;
            value.map(v => {
                if (v.length > 10) {
                    flag = false
                }
            })
            if (!flag) {
                callback(new Error('标签最多10个字符!'));
            } else {
                callback();
            }
        }


        return {
            formData: {
                ...defaultFormData
            },
            rules: {
                cover: [{ required: true, message: "请上传项目封面" }],
                // videoUrl: [{ required: true, message: "请上传项目视频" }],
                name: [{ required: true, message: "请填写项目名称" }],
                datetimerange: [{ required: true, message: "请填写申购时间" }],
                publicityTime: [{ required: true, message: "请填写中签公示时间" }],
                goodsId: [{ pattern: /^[0-9]+$/, message: "请输入正确的ID" }],
                // detail: [{ required: true, message: "请填写项目详情" }],
                tagsList: [{ validator: checkTag }]
            },

            dataLoading: false,
            btnLoading: false,

            redirect: this.$route.query.redirect || '/promotion/subscribe/list',

            toolbar: ['formatselect fontsizeselect | forecolor bold strikethrough | alignleft aligncenter alignright alignjustify | image media'],
            reFresh: false,

            userLoading: false,
            userList: [],

            videoUrl: "",
            coverUrl: "",
        }
    },
    mounted() {
        if (this.id) {
            this.getDetailData();
        } else {
            this.formData = {
                ...defaultFormData,
                bannerList: []
            }
            this.reFresh = true;
        }
    },
    methods: {
        //获取详情
        getDetailData() {
            this.dataLoading = true;
            this.$request({
                url: "/subscribe/detail",
                method: "POST",
                params: {
                    id: this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.formData = {
                            ...defaultFormData,
                            ...result,
                            datetimerange: result.startTime ? [result.startTime, result.endTime] : [],
                            authorObj: {
                                id: result.author || '',
                                name: result.authorName || ''
                            }
                        };

                        if (result.author) {
                            this.userList = [{
                                id: result.author,
                                name: result.authorName
                            }]
                        }

                        this.coverUrl = result.cover;
                        this.videoUrl = result.videoUrl;

                        this.reFresh = true;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        // 搜索用户
        searchUser(query) {
            this.gethUser(query, -1, "userList");
        },
        async gethUser(query, userType, obj) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue: query,
                    userType: userType,
                }).finally(() => {
                    this.userLoading = false;
                });

                const { state, result } = res.data;

                if (state == 1 && result) {
                    this[obj] = result;
                }
            }
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _endTime = new Date(this.formData.datetimerange[1].replaceAll('-', '/')).getTime(),
                        _publicityTime = new Date(this.formData.publicityTime.replaceAll('-', '/')).getTime();

                    if (_endTime >= _publicityTime) {
                        return this.$message.error('中签公示时间需晚于申购结束时间，请重新填写');
                    }

                    if (this.$refs.bannerForm && this.$refs.bannerForm.getWList().length > 0) {
                        this.$confirm('存在上传中或待上传的文件，提交后将无法保存这些文件，确认提交吗？', '提交', {
                            confirmButtonText: '确认提交',
                            cancelButtonText: '稍后提交',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                            center: true
                        }).then(() => {
                            this.submitAction();
                        }).catch(() => {

                        });
                    } else {
                        this.submitAction();
                    }


                } else {
                    return false;
                }
            });
        },
        submitAction() {
            this.btnLoading = true;

            this.$request({
                url: '/subscribe/save',
                method: "post",
                data: {
                    ...this.formData,
                    startTime: this.formData.datetimerange[0],
                    endTime: this.formData.datetimerange[1],
                    author: this.formData.authorObj ? this.formData.authorObj.id : "",	//作者id
                    authorName: this.formData.authorObj ? this.formData.authorObj.name : "",	//作者名称
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.goBack();
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        },
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
    }
}
</script>